(() => {
  if (window.pbChristmasInitialized) return;
  window.pbChristmasInitialized = true;
  const timerLimit = 2147483647;
  let expiryTimer;
  const canCopy = () => window.isSecureContext && typeof navigator.clipboard?.writeText === 'function';
  const refresh = () => {
    window.clearTimeout(expiryTimer);
    const now = Date.now();
    let nextExpiry = Infinity;
    document.querySelectorAll('[data-pb-xmas-end]').forEach((element) => {
      const expiry = Date.parse(element.dataset.pbXmasEnd);
      if (!Number.isFinite(expiry) || expiry <= now) {
        element.hidden = true;
        return;
      }
      nextExpiry = Math.min(nextExpiry, expiry);
      element.querySelectorAll('[data-pb-xmas-copy]').forEach((button) => {
        button.hidden = !canCopy();
      });
    });
    if (Number.isFinite(nextExpiry)) {
      expiryTimer = window.setTimeout(refresh, Math.min(Math.max(nextExpiry - now, 1), timerLimit));
    }
  };
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-pb-xmas-copy]');
    if (!button || button.disabled || button.hidden || !canCopy()) return;
    const hint = button.closest('[data-pb-xmas-end]');
    const expiry = Date.parse(hint?.dataset.pbXmasEnd);
    if (!hint || hint.hidden || !Number.isFinite(expiry) || expiry <= Date.now()) {
      refresh();
      return;
    }
    const feedback = hint.querySelector('[data-pb-xmas-feedback]');
    button.disabled = true;
    try {
      await navigator.clipboard.writeText(button.dataset.pbXmasCopy);
      if (feedback) feedback.textContent = button.dataset.pbXmasSuccess;
    } catch {
      if (feedback) feedback.textContent = button.dataset.pbXmasError;
    } finally {
      button.disabled = false;
    }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  const observer = new MutationObserver((changes) => {
    if (changes.some((change) => change.addedNodes.length || change.removedNodes.length)) refresh();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
